import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Autocomplete, CircularProgress, Tab, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import DOSEN_ROLES from "../../../utils/constants/DosenRoles.constants";
import TermService from "../../../services/Integration/term/TermService";
import SidangDosenChild from "./sidang-list/SidangDosenChild";

let currentTerm = {
  id_term: null,
  periode: null,
  semester: null,
};

export default function SidangDosen() {
  const [isLoading, setIsLoading] = useState(true);
  const [tabValue, setTabValue] = useState(currentTab());
  const [terms, setTerms] = useState([]);
  const [termSelected, setTermSelected] = useState(currentTerm);

  function currentTab() {
    const path = window.location.hash;
    if (path.includes("pembimbing")) return "1";
    else if (path.includes("penguji")) return "2";
    return "1";
  }

  function setCurrentTermSelected(term) {
    currentTerm = { ...term };
    setTermSelected(currentTerm);
  }

  useEffect(() => {
    const loadFormDatas = async () => {
      await getTermsList();
      setIsLoading(false);
    };
    
    loadFormDatas();
  }, []);

  const getTermsList = async () => {
    await TermService.getTermList()
      .then((response) => {
        if (response.status === 200) {
          setTerms(response.data);
          if (!termSelected.id_term) {
            setCurrentTermSelected(response.data[0]);
          }
        }
      })
      .catch((response) => console.log(response));
  };

  return (
    <div className="mb-4">
      <h2 className="font-bold">Beranda</h2>
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          {!terms?.length ? (
            <h2 className="text-center">
              Tidak ada pilihan semester, silakan buat Semester terlebih dahulu
            </h2>
          ) : (
            <>
              <Autocomplete
                sx={{ width: 250, paddingY: 2 }}
                size="small"
                id="semester"
                value={termSelected}
                onChange={(event, newValue) => {
                  if (newValue) setCurrentTermSelected(newValue);
                }}
                options={terms}
                noOptionsText={"Semester tidak ditemukan"}
                getOptionLabel={(option) =>
                  option.semester && option.periode
                    ? option.semester + " " + option.periode
                    : ""
                }
                isOptionEqualToValue={(option, value) =>
                  option.id_term === value.id_term
                }
                renderOption={(props, option) => (
                  <span {...props}>
                    {option.semester} {option.periode}
                  </span>
                )}
                defaultValue={termSelected}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Semester"
                    required={true}
                    variant="filled"
                    size="medium"
                  />
                )}
              />

              <TabContext value={tabValue}>
                <TabList onChange={(e, value) => setTabValue(value)}>
                  <Tab
                    href="#pembimbing"
                    label={<span className="px-4">Mahasiswa Bimbingan</span>}
                    value={"1"}
                  />
                  <Tab
                    href="#penguji"
                    label={<span className="px-4">Mahasiswa yang Diuji</span>}
                    value={"2"}
                  />
                </TabList>
                <TabPanel value={"1"} sx={{ padding: 0 }}>
                  <SidangDosenChild
                    dosenRole={DOSEN_ROLES.pembimbing}
                    term={termSelected.id_term}
                  />
                </TabPanel>
                <TabPanel value={"2"} sx={{ padding: 0 }}>
                  <SidangDosenChild
                    dosenRole={DOSEN_ROLES.penguji}
                    term={termSelected.id_term}
                  />
                </TabPanel>
              </TabContext>
            </>
          )}
        </>
      )}
    </div>
  );
}
